import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
interface ReviewProps {
  initials: string;
  color: string;
  name: string;
  reviews: number;
  country: string;
  date: string;
  verified?: boolean;
  stars: number;
  title: string;
  text: string;
}
function ReviewCard({
  initials,
  color,
  name,
  reviews,
  country,
  date,
  verified,
  stars,
  title,
  text
}: ReviewProps) {
  return <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-gray-200 mb-6" data-id="element-132">
      <div className="flex items-start justify-between mb-4" data-id="element-133">
        <div className="flex items-center" data-id="element-134">
          <div className={`w-10 h-10 rounded-full ${color} flex items-center justify-center text-white font-bold text-sm mr-4`} data-id="element-135">
            {initials}
          </div>
          <div data-id="element-136">
            <div className="flex items-center text-sm font-medium text-gray-900" data-id="element-137">
              {name}
              <span className="mx-2 text-gray-300" data-id="element-138">•</span>
              <span className="text-gray-500" data-id="element-139">{reviews} reviews</span>
              <span className="mx-2 text-gray-300" data-id="element-140">•</span>
              <span className="text-gray-500" data-id="element-141">{country}</span>
            </div>
            {verified && <div className="flex items-center text-xs text-green-600 mt-1 font-medium" data-id="element-142">
                <CheckCircle size={12} className="mr-1" data-id="element-143" />
                Geverifieerd
              </div>}
          </div>
        </div>
        <span className="text-xs text-gray-400 font-medium" data-id="element-144">{date}</span>
      </div>

      <div className="flex mb-3" data-id="element-145">
        {[...Array(5)].map((_, i) => <div key={i} className={`w-6 h-6 ${i < stars ? 'bg-[#00b67a]' : 'bg-gray-200'} mr-1 flex items-center justify-center rounded-sm`} data-id="element-146">
            <Star size={14} className="text-white fill-current" data-id="element-147" />
          </div>)}
      </div>

      <h4 className="font-bold text-gray-900 text-lg mb-2" data-id="element-148">{title}</h4>
      <p className="text-gray-600 text-base leading-relaxed" data-id="element-149">{text}</p>
    </div>;
}
export function TrustpilotReviews() {
  const reviews = [{
    initials: 'TI',
    color: 'bg-purple-500',
    name: 'Tine',
    reviews: 4,
    country: 'BE',
    date: '3 sep 2024',
    stars: 5,
    title: 'Niet goed maar uitstekend',
    text: "Amée is een zeer lieve vrouw met een hart voor honden en dat merk je zeer goed. De tips helpen echt. Ik raad iedereen met puppy's, jongere hondjes en alle andere leeftijden deze cursus aan."
  }, {
    initials: 'NI',
    color: 'bg-blue-500',
    name: 'Nicolette',
    reviews: 2,
    country: 'NL',
    date: '8 jul 2024',
    verified: true,
    stars: 5,
    title: 'Hele fijne cursus. Aanrader zelfs voor de ervaren honden liefhebber.',
    text: "In kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm enthousiast over deze cursus. Het is netjes overzichtelijk, duidelijk maar wat met het meeste aanspreekt is dat het zonder commando's gaat maar via communiceren."
  }, {
    initials: 'MA',
    color: 'bg-green-500',
    name: 'Margreet',
    reviews: 4,
    country: 'NL',
    date: '20 apr 2024',
    stars: 5,
    title: 'Dit was de eerste keer dat ik een online hondencursus volgde...',
    text: 'mijn honden nu veel rustiger communiceren met andere honden. Vooral met onbekende honden was er toch vaak wel flink geblaf. Nu bijna niet meer, heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!'
  }, {
    initials: 'HB',
    color: 'bg-orange-500',
    name: 'Henne Buskermolen',
    reviews: 4,
    country: 'NL',
    date: '13 aug 2024',
    stars: 4,
    title: 'Ik vond het prettig mijn ervaring op te...',
    text: 'Ik vond het prettig mijn ervaring op te halen en voorbereid te zijn op de puppy die ik al snel krijg. Goed gewerkt!'
  }];
  return <div className="my-16" data-id="element-150">
      <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-151">
        <Star className="text-[#00b67a] fill-[#00b67a] mr-3" data-id="element-152" />
        Wat cursisten over ons zeggen
      </h3>
      <div className="space-y-6" data-id="element-153">
        {reviews.map((review, index) => <ReviewCard key={index} {...review} data-id="element-154" />)}
      </div>
    </div>;
}